import React from "react";
import "./ProblemIntro.scss";

const ProblemIntro = () => {
  return (
    <section className="problem-intro" aria-label="Problem introduction">
      <div className="pi__inner">
        <p className="pi__kicker">Why most service businesses stall</p>

        <h2 className="pi__title">
          Your work is a 10/10, but Dave hired the guy with the better logo.
        </h2>

        <p className="pi__lead">
          Most service businesses lose contracts not because of what they do, but because of how they look when they show up. Competing against larger, better-branded firms on proposals, websites, and first impressions is a gap that skill alone cannot close.
        </p>

        <p className="pi__lead">
          <strong>BrandKeeper™ steps in to keep everything aligned.</strong> We manage your brand
          system and bring every asset back to center so your content stays sharp, cohesive, and
          ready to scale. It keeps your brand steady while you focus on building the business.
        </p>
      </div>
    </section>
  );
};

export default ProblemIntro;
